import mapImage from "@assets/images/Group-1410087709.svg";
import uaeMapImage from "@assets/images/Group-1410087713@2x.png";
import buttonArrowIcon from "@assets/images/Frame-91.svg";
import { Reveal } from "@components/ui";

export function TrustSection() {
  return (
    <section className="w-full bg-white overflow-hidden py-10 md:py-14 lg:py-[120px] px-5 md:px-10 lg:px-[180px]">
      <div className="w-full max-w-[1368px] mx-auto flex flex-col lg:flex-row items-stretch gap-5">
        {/* Left Card - Trust */}
        <Reveal direction="left" className="w-full lg:w-[671px]">
          <div className="w-full h-full min-h-[450px] md:min-h-[550px] lg:min-h-[964px] rounded-[12px] md:rounded-[24px] bg-[#f24d2b] flex flex-col items-start pt-8 md:pt-12 lg:pt-20 px-4 md:px-6 lg:px-[68px] pb-[180px] md:pb-[220px] lg:pb-[36px] relative overflow-hidden">
            {/* Content */}
            <div className="w-full max-w-[534px] flex flex-col items-start gap-3.5 z-10">
              <h2 className="text-[24px] md:text-[40px] lg:text-[54px] tracking-[-0.04em] font-semibold text-[#fffcfb] font-albert-sans leading-[1.1]">
                Trusted by communities across the UAE
              </h2>
              <p className="text-[14px] md:text-base lg:text-[24px] tracking-[-0.04em] text-[#ffe3e3] font-albert-sans">
                From residential towers in Dubai to industrial sites in Sharjah,
                Gas Integrated Solutions L.L.C. powers communities with safety,
                reliability, and technology-driven efficiency.
              </p>
            </div>

            {/* Trophy */}
            <div className="w-[180px] md:w-[240px] lg:w-[317px] h-[280px] md:h-[370px] lg:h-[489.4px] mt-6 md:mt-8 lg:mt-12 z-[1] mx-auto md:mx-0 md:ml-2 lg:ml-4">
              <img
                src={mapImage}
                alt=""
                className="w-full h-full object-contain"
              />
            </div>

            {/* UAE Map Overlay */}
            <img
              src={uaeMapImage}
              alt="UAE coverage map"
              className="hidden md:block absolute md:top-[380px] md:left-[180px] md:w-[300px] md:h-[380px] lg:top-[510.8px] lg:left-[252px] lg:w-[419.4px] lg:h-[521.1px] object-contain z-[2]"
              loading="lazy"
            />
          </div>
        </Reveal>

        {/* Right Column */}
        <Reveal direction="right" className="flex-1 min-w-0 lg:min-w-[441px] flex flex-col gap-5">
          {/* Cleaner Energy Card */}
          <div className="group w-full rounded-[12px] md:rounded-[24px] bg-[#fff5f5] flex items-start p-3 md:p-6 lg:pt-[54px] lg:px-[34px] lg:pb-[54px] hover:shadow-[0_8px_32px_rgba(0,0,0,0.08)] transition-all duration-300">
            <div className="w-full max-w-[610px] flex flex-col items-start gap-4 lg:gap-[21px]">
              <h3 className="text-[24px] md:text-[36px] lg:text-[48px] tracking-[-0.04em] font-semibold text-[#122d63] font-albert-sans leading-[1.1] lg:whitespace-nowrap">
                Cleaner Energy, Safer Future.
              </h3>
              <p className="text-[14px] md:text-base lg:text-[26px] tracking-[-0.04em] text-[#62636c] font-albert-sans">
                GASIS invests in energy-efficient infrastructure and
                emission-reduction technologies that align with the UAE's
                sustainability goals and Net Zero 2050 vision.
              </p>
              <button className="flex items-center gap-2.5 text-xs md:text-base lg:text-[24px] tracking-[-0.04em] font-normal text-[#0a0e2e] font-albert-sans hover:opacity-80 transition-opacity">
                <span>Learn More</span>
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  className="w-5 h-5 md:w-6 md:h-6 transition-transform duration-300 group-hover:translate-x-1"
                >
                  <path
                    d="M5 12h14M12 5l7 7-7 7"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
            </div>
          </div>

          {/* Connect Card */}
          <div className="group w-full flex-1 rounded-[12px] md:rounded-[24px] bg-[#dbdbdb] flex items-start p-3 md:p-6 lg:pt-[103px] lg:px-[68px] lg:pb-[103px] hover:shadow-[0_8px_32px_rgba(0,0,0,0.08)] transition-all duration-300">
            <div className="w-full max-w-[492px] flex flex-col items-start gap-16 lg:gap-[120px]">
              <div className="flex flex-col items-start gap-1">
                <h3 className="text-[24px] md:text-[40px] lg:text-[54px] tracking-[-0.04em] font-bold text-[#090d2c] font-albert-sans leading-[1.1]">
                  Ready to Connect with GASIS?
                </h3>
                <p className="text-[14px] md:text-base lg:text-[24px] tracking-[-0.04em] text-[#1e1f24] font-albert-sans">
                  Apply for a new gas connection today and our technical team
                  will schedule your site visit within 48 hours.
                </p>
              </div>

              <button className="flex items-center gap-2.5 py-3 pl-5 pr-2 bg-[#fffcfb] rounded-[40px] text-xs md:text-base lg:text-[24px] tracking-[-0.04em] text-[#1e1f24] font-albert-sans hover:bg-[#e6e3e0] transition-colors">
                <span>Access my account</span>
                <img
                  src={buttonArrowIcon}
                  alt=""
                  className="w-10 h-10 rounded-full transition-transform duration-300 group-hover:translate-x-1"
                />
              </button>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
